import { Amplify } from '@aws-amplify/core';
import awsconfig from './../aws-exports';
import { Auth } from '@aws-amplify/auth';

export const AWSAuth = {
  signOut: async() => {
    Amplify.configure(awsconfig);
    try {
      return await Auth.signOut({ global: true });
    } catch (error) {
      return error;
  }
  },
  resend: async(username) => {
    Amplify.configure(awsconfig);
    try {
      return await Auth.resendSignUp(username);
    } catch (err) {
      return err;
    }
  },
  getUser: async() => {
    Amplify.configure(awsconfig);
    try {
      return await Auth.currentAuthenticatedUser();
    } catch (error) {
      return error;
    }
  },
  updateMember: async(user, attributes) => {
    Amplify.configure(awsconfig);
    try {
      return await Auth.updateUserAttributes(user, attributes);
    } catch (error) {
      return error;
    }
  },
  signIn: async(username, password) => {
    Amplify.configure(awsconfig);
    try {
      const member = await Auth.signIn(username, password);
      return member;
    } catch (error) {
      return error;
    }
  },
  signUp: async (username, password, email, genero, marketing, discountCode) => {
    Amplify.configure(awsconfig);
    try {
      const startDate = new Date();
      let endDate = new Date();
      endDate.setDate(startDate.getDate() + 7);
      let membershipInfo = [startDate.getTime() + '|' + endDate.getTime() + '|free'];
      let paymentInfo = {
        tx: null,
        v: endDate.getTime(),
      };
      let subscriptionInfo = {
        p: 'free',
      };
      const acceptedMarketing = (marketing === true) ? 'y' : 'n';
      const memberParams = {
        username,
        password,
        attributes: {
          // user attributes
          email,
          gender: genero,
          picture: '',
          // marketing
          'custom:signedOnToMarketing': acceptedMarketing,
          // registration
          'custom:signup_type': 'email',
          // membership
          'custom:membershipInfo': JSON.stringify(membershipInfo),
          // payment
          'custom:txInfo': JSON.stringify(paymentInfo),
          // subscriptions
          'custom:subscriptionInfo': JSON.stringify(subscriptionInfo),
          // subscriptions
          'custom:isStaff': 0,
        }
      }
      return await Auth.signUp(memberParams);
    } catch (error) {
      console.error('Error signing up:' + error);
      return error;
    }
  },
  forgotPassword: async(username) => {
    Amplify.configure(awsconfig);
    try {
      return await Auth.forgotPassword(username);
    } catch (error) {
      console.error('Error resetting password:' + error);
      return error;
    }
  },
  forgotPasswordSubmit: async(username, code, new_password) => {
    Amplify.configure(awsconfig);
    try {
      return await Auth.forgotPasswordSubmit(username, code, new_password);
    } catch (error) {
      console.error('Error resetting password:' + error);
      return error;
    }
  },
  isAnonymous: async () => {
    Amplify.configure(awsconfig);
    try {
      const member = await Auth.currentAuthenticatedUser();
    } catch (err) {
      return err;
    }
    if (typeof member === 'string' && member === 'not authenticated') {
      return true;
    }else if ((typeof member === 'object') && member.attributes) {
      return false;
    }
  },
  hasValidSubscription: async () => {
    const today = new Date();
    let member = null;
    Amplify.configure(awsconfig);
    try {
      member = await Auth.currentAuthenticatedUser();
    } catch (err) {
      console.error(err);
      return false;
    }
    // Allow cognito staff members to access all content
    if (member.attributes['custom:isStaff'] === "1") {
      return true;
    }
    // otherwise check subscription info
    const subscriptionInfo = JSON.parse(member.attributes['custom:subscriptionInfo']);
    if (subscriptionInfo.p === 'free') {
      return subscriptionInfo.p;
    }
    const currentSubscription = JSON.parse(member.attributes['custom:txInfo']);
    return today.getTime() <= currentSubscription.v;
  },
};
